import Vuex from "vuex";
import { createLocalVue, shallowMount } from "@vue/test-utils";
import EmailField from "@/components/core/EmailField";

const localVue = createLocalVue();
localVue.use(Vuex);

describe("EmailField Component mount", () => {
  let wrapper;
  let store;
  let getters;

  const props = {
    value: "String"
  };

  beforeEach(() => {
    getters = {
      getContacto: function () {
        return () => ({
          contacto: {
            email: "",
            emailConfirm: "",
            celular: {
              numero: ""
            },
            validEmail: false,
            validNumber: false
          }
        });
      }
    };

    store = new Vuex.Store({ getters });
    wrapper = shallowMount(EmailField, {
      mocks: {
        subscribe: () => () => ""
      },
      store,
      localVue,
      propsData: props
    });
  });

  it("Renders del component EmailField", () => {
    expect(wrapper).toBeDefined();
  });
});
